import { useCallback, useState } from 'react';
import { asyncValidateEmail, validateEmail } from '../../lib/models/email';
import { sendResults } from '../../lib/use-cases/send-results';
import { logEvent } from '../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../lib/shared/event-types';
import config from '../../config';

function useSendResults(saveEmail, afterCallback) {
    const [isPending, setIsPending] = useState(false);
    const [fields, setFields] = useState({ email: '' });
    const [errors, setErrors] = useState({ email: '', form: '' });

    const changeField = useCallback((name, value) => {
        if (errors[name] || errors.form) {
            setErrors(prevState => ({ ...prevState, [name]: '', form: '' }));
        }

        setFields(prevState => ({ ...prevState, [name]: value }));
    }, [errors]);

    const submitForm = async (e) => {
        e.preventDefault();

        try {
            setIsPending(true);

            const validationData = validateEmail(fields.email);

            if (!validationData.isValid) {
                return setErrors(prevState => ({ ...prevState, email: validationData.message }));
            }

            const asyncValidationData = await asyncValidateEmail(fields.email);

            if (!asyncValidationData.isValid) {
                if (asyncValidationData.data?.didYouMean) {
                    return setErrors(prevState => ({ ...prevState, form: { message: asyncValidationData.message, didYouMean: asyncValidationData.data.didYouMean } }));
                }

                return setErrors(prevState => ({ ...prevState, form: { message: asyncValidationData.message } }));
            }

            await sendResults({ email: fields.email });

            afterCallback(() => {
                saveEmail(fields.email);
                logEvent(EVENT_TYPES.EMAIL_SUBMITTED);
            });
        } catch (error) {
            if (error?.code === 'wrongTenant') {
                if (window.confirm(error.message)) {
                    window.location.href = config.sisterWebsiteUrl;
                }

                return;
            }

            setErrors(prevState => ({ ...prevState, form: { message: `The email ${fields.email} may have a mistake or might not work.` } }));
        } finally {
            setIsPending(false);
        }
    };

    return {
        fields,
        errors,
        isPending,
        submitForm,
        changeField
    };
}

export {
    useSendResults
};
